import { Box, IBoxProps } from 'native-base';
import React, { ReactNode } from 'react';

import { DEFAULT_PADDING } from 'app/components/ResponsiveContainer';
import useEffectiveBottomInset from 'app/hooks/useEffectiveBottomInset';
import { tID } from 'app/services/TestHelper';

export type FixedBottomProps = IBoxProps & {
  children?: ReactNode;
  padded?: boolean;
};

export default function FixedBottom({ children, padded, ...props }: FixedBottomProps) {
  const bottomInset = useEffectiveBottomInset();
  return (
    <Box
      bottom="0"
      left="0"
      position="absolute"
      px={padded ? DEFAULT_PADDING : undefined}
      py={padded ? DEFAULT_PADDING : undefined}
      right="0"
      testID={tID('FixedBottom')}
      w="full"
      {...props}
    >
      {children}
      {/* keep `!!` --- a bare 0 renders as stray text and crashes RN. */}
      {!!bottomInset && <Box h={`${bottomInset}px`} />}
    </Box>
  );
}
